import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    appBar: {
        bottom: 0,
        background: `linear-gradient(356deg, rgba(2,0,36,1) 3%, rgb(31 85 138) 96%)`,
        display: 'flex',
        justifyContent: 'center',
        top: 'auto',
        alignItems: "center"
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: "center"
    },
    img:{
        height: 20,
        marginRight: 10,
        width: 20,
    },    
    imgTwo:{
        height: 25,
        marginRight: 5,
        width: 25,
    },    
    title: {
        marginRight: 10,
        '@media (max-width:460px)':{ //mobile
            fontSize: "0.6rem",
        }

    },
    lastTitle: {
        marginLeft: 10,
        '@media (max-width:460px)':{ //mobile
            fontSize: "0.6rem",
        }
    },
    appIcon: {
        width: 25,
        height: 25,
        marginRight: 10,
    },
}));